function initForm() {
  if ($('.form-module .gform_wrapper').length == 0) {
    return false;
  }

  jQuery(document).on('gform_post_render', function(event, form_id){
    if (1 === form_id) {
      $('body .gform_wrapper .gfield input, body .gform_wrapper .gfield textarea').each(function() {
        if ($(this).val()) {
          $(this).parent().parent().find('.gfield_label').addClass('active');
        }
      });
    }
  });

  $('body').on('focus', '.gform_wrapper .gfield input, .gform_wrapper .gfield textarea', function () {
    $(this).parent().parent().find('.gfield_label').addClass('active');
  });

  $('body').on('focusout', '.gform_wrapper .gfield input, .gform_wrapper .gfield textarea', function () {
    if (!$(this).val()) {
      $(this).parent().parent().find('.gfield_label').removeClass('active');
    }
  });
}

export { initForm }



// WEBPACK FOOTER //
// ./scripts/modules/forms.js